import React, { useEffect, useState } from "react";
import { CheckCircleIcon } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { CHECKOUT_URL } from "./data";

// Appears once the user scrolls past the first hero CTA button.
export function FloatingCTA({
  triggerId
}: {
  triggerId: string;
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const trigger = document.getElementById(triggerId);
    if (!trigger) return;
    const observer = new IntersectionObserver(([entry]) => {
      // show once the trigger has scrolled out of the top of the viewport
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, [triggerId]);
  const handleClick = () => {
    if (typeof window !== "undefined" && (window as any).fbq) {
      (window as any).fbq("track", "InitiateCheckout");
    }
  };
  return <AnimatePresence data-id="element-105" data-mp="2z27lsty5rgry">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: "spring",
      stiffness: 300,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2" data-id="element-106" data-mp="2z38zz7ah0jdw">
          <div className="mx-auto max-w-lg" data-id="element-107" data-mp="2u9xzdnw94yuf">
            <a href={CHECKOUT_URL} onClick={handleClick} className="flex w-full items-center justify-center gap-2 rounded-2xl bg-[var(--cta)] px-4 py-4 text-center text-sm font-extrabold uppercase tracking-wide text-white shadow-[0_-4px_24px_rgba(0,0,0,0.25)] transition-colors hover:bg-[var(--cta-dark)] sm:text-base" data-id="element-108" data-mp="2fdyhxmn95mcm">
              <CheckCircleIcon className="h-5 w-5 shrink-0" strokeWidth={2.5} data-id="element-109" data-mp="2bcn0w5ig29g1" />
              Obtener por USD $15
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}